import { LegalLayout, LegalSection } from "@/components/LegalLayout";

export default function TermsPage() {
  return (
    <LegalLayout
      eyebrow="Handelsbetingelser"
      title="Handelsbetingelser for Aicom AI"
      updated="juni 2026"
      intro="Velkommen til Aicom AI. Ved at oprette en konto eller købe et abonnement accepterer du nedenstående handelsbetingelser."
    >

        <LegalSection title="1. Om Aicom AI">
          <p>Aicom AI er en abonnementsbaseret softwareplatform (SaaS), der hjælper virksomheder med kommunikation, contentproduktion, branding og markedsføring ved hjælp af kunstig intelligens.</p>
          <p>Aicom AI ejes og drives af:</p>
          <p className="text-foreground">
            PointTaken I/S<br />
            CVR. nr.: 38540807<br />
            Telefon: 53 82 38 30<br />
            Email: <a href="mailto:kontakt@pointtaken.dk" className="underline underline-offset-4 hover:no-underline">kontakt@pointtaken.dk</a>
          </p>
        </LegalSection>

        <LegalSection title="2. Oprettelse af konto">
          <p>For at benytte Aicom AI skal virksomheden oprette en brugerprofil.</p>
          <p>Brugeren er ansvarlig for, at:</p>
          <ul className="list-disc pl-5 space-y-2">
            <li>oplysningerne er korrekte</li>
            <li>loginoplysninger opbevares sikkert</li>
            <li>uvedkommende ikke får adgang til kontoen.</li>
          </ul>
          <p>Virksomheden er ansvarlig for al aktivitet, der sker via virksomhedens konto.</p>
        </LegalSection>

        <LegalSection title="3. Abonnement">
          <p>Aicom AI sælges som et løbende abonnement.</p>
          <ul className="list-disc pl-5 space-y-2">
            <li>Abonnementet betales forud.</li>
            <li>Betalingen sker automatisk via den valgte betalingsmetode.</li>
            <li>Abonnementet fortsætter, indtil det opsiges.</li>
          </ul>
        </LegalSection>

        <LegalSection title="4. Opsigelse">
          <ul className="list-disc pl-5 space-y-2">
            <li>Abonnementet kan opsiges når som helst.</li>
            <li>Opsigelsen gælder fra udgangen af den allerede betalte abonnementsperiode.</li>
            <li>Der sker ikke tilbagebetaling for allerede betalte perioder.</li>
            <li>Beder du om at få din betalende konto slettet, opsiges abonnementet i den forbindelse, og der refunderes ikke for den resterende del af den allerede betalte periode.</li>
          </ul>
        </LegalSection>

        <LegalSection title="5. Priser">
          <ul className="list-disc pl-5 space-y-2">
            <li>Alle priser vises eksklusive eller inklusive moms afhængigt af kundetypen.</li>
            <li>Aicom forbeholder sig retten til at ændre priser.</li>
            <li>Prisændringer varsles minimum 30 dage før de træder i kraft.</li>
          </ul>
        </LegalSection>

        <LegalSection title="6. Betaling">
          <ul className="list-disc pl-5 space-y-2">
            <li>Betaling håndteres via Stripe.</li>
            <li>Ved manglende betaling kan adgangen til platformen suspenderes eller lukkes.</li>
          </ul>
        </LegalSection>

        <LegalSection title="7. Brug af AI">
          <p>Aicom AI anvender kunstig intelligens til at generere forslag, analyser og tekst.</p>
          <p>Det genererede indhold er vejledende. Virksomheden er altid ansvarlig for at gennemlæse, redigere og godkende indholdet, inden det offentliggøres eller anvendes.</p>
          <p>Aicom garanterer ikke, at AI-genereret indhold er fejlfrit, juridisk korrekt eller egnet til et bestemt formål.</p>
        </LegalSection>

        <LegalSection title="8. Pressevurderinger og analyser">
          <p>Funktioner som pressepotentiale, kommunikationsanalyser og strategiske anbefalinger bygger på AI-baserede vurderinger.</p>
          <p>Resultaterne er rådgivende og må ikke betragtes som garantier for medieomtale, SEO-resultater eller markedsføringsmæssig effekt.</p>
        </LegalSection>

        <LegalSection title="9. Immaterielle rettigheder">
          <p>Virksomheden ejer de tekster og det indhold, som virksomheden selv genererer gennem platformen.</p>
          <p>Aicom AI og platformens software, design, funktioner, prompts, modeller og teknologi tilhører Aicom og må ikke kopieres, videresælges eller distribueres uden skriftlig tilladelse.</p>
        </LegalSection>

        <LegalSection title="10. Kundedata">
          <p>Virksomheden bevarer ejerskabet over de data, dokumenter og filer, der uploades til platformen.</p>
          <p>Aicom anvender alene oplysningerne til at levere og forbedre tjenesten. Personoplysninger behandles i henhold til Aicoms privatlivspolitik.</p>
        </LegalSection>

        <LegalSection title="11. Oppetid">
          <p>Vi bestræber os på høj oppetid. Der kan dog forekomme planlagt vedligeholdelse eller uforudsete driftsforstyrrelser.</p>
          <p>Aicom kan ikke holdes ansvarlig for tab som følge af midlertidig utilgængelighed.</p>
        </LegalSection>

        <LegalSection title="12. Ansvarsbegrænsning">
          <p>Aicom AI leveres "som den er".</p>
          <p>Aicom er ikke ansvarlig for indirekte tab, herunder driftstab, tabt avance, tabte kunder, tabte data eller følgeskader.</p>
          <p>Aicoms samlede ansvar kan aldrig overstige det beløb, kunden har betalt i abonnement de seneste 12 måneder.</p>
        </LegalSection>

        <LegalSection title="13. Misbrug">
          <p>Det er ikke tilladt at:</p>
          <ul className="list-disc pl-5 space-y-2">
            <li>anvende platformen til ulovlige formål</li>
            <li>generere ulovligt eller krænkende indhold</li>
            <li>forsøge at kopiere eller omgå platformens funktioner</li>
            <li>dele login med uvedkommende</li>
            <li>anvende platformen på en måde, der skader Aicom eller andre brugere.</li>
          </ul>
          <p>Ved væsentligt misbrug kan kontoen lukkes uden varsel.</p>
        </LegalSection>

        <LegalSection title="14. Ændringer">
          <p>Aicom kan løbende udvikle og ændre platformens funktioner.</p>
          <p>Vi forbeholder os retten til at tilføje, ændre eller fjerne funktioner, når det er nødvendigt.</p>
        </LegalSection>

        <LegalSection title="15. Lovvalg">
          <p>Enhver tvist afgøres efter dansk ret. Værneting er Aicoms hjemting.</p>
        </LegalSection>

        <LegalSection title="16. Kontakt">
          <p>Har du spørgsmål til handelsbetingelserne, kan du kontakte:</p>
          <p className="text-foreground">
            PointTaken I/S<br />
            E-mail: <a href="mailto:kontakt@pointtaken.dk" className="underline underline-offset-4 hover:no-underline">kontakt@pointtaken.dk</a>
          </p>
        </LegalSection>

        <LegalSection title="Accept ved køb">
          <p>Ved at oprette en konto eller gennemføre et køb bekræfter jeg, at:</p>
          <ul className="space-y-3">
            <li className="flex gap-3"><span className="text-foreground">☑</span><span>Jeg har læst og accepterer handelsbetingelserne.</span></li>
            <li className="flex gap-3"><span className="text-foreground">☑</span><span>Jeg accepterer, at levering af den digitale tjeneste påbegyndes med det samme, og at min eventuelle fortrydelsesret bortfalder i det omfang, dette følger af gældende regler om digitale tjenester.</span></li>
          </ul>
        </LegalSection>
    </LegalLayout>
  );
}
